import { PasswordRequirementRegexes } from './constants';

export const getPasswordStrength = (password: string) => {
  let failedRequirementCount = password.length >= 8 ? 0 : 1;

  PasswordRequirementRegexes.forEach((requirement) => {
    if (!requirement.re.test(password)) {
      failedRequirementCount += 1;
    }
  });

  return Math.max(
    100 -
      (100 / (PasswordRequirementRegexes.length + 1)) * failedRequirementCount,
    0,
  );
};
